import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export class ErrorBoundary extends React.PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      hasError: false
    });
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    this.props.onErrorReported(error);
  }
  render() {
    const {
      children,
      forceToShow
    } = this.props;
    const {
      hasError
    } = this.state;
    if (hasError || forceToShow) {
      return ___EmotionJSX("div", {
        className: "dc-u-fx dc-u-fx-aic dc-u-fx-jcc dc-u-h-100pc dc-u-bgc-grey-400 dc-u-ta-center"
      }, ___EmotionJSX("h4", null, "Something went wrong, please reload the page or visit our", ' ', ___EmotionJSX("a", {
        href: "https://support.datacamp.com/",
        rel: "noopener noreferrer"
      }, "Support page"), ' ', "if the problem persists."));
    }
    if (!children) {
      return null;
    }
    return children;
  }
}
_defineProperty(ErrorBoundary, "defaultProps", {
  forceToShow: false
});